import React from 'react'
import { Header, Content, Footer } from './index'
import { homeRoutes } from '../routes/index'

function Home() {
  return (
    <div className="d-flex flex-column vh-100">
      <Header />
      <div>
        <Content routes={homeRoutes} />
      </div>
      <Footer />
    </div>
  )
}

export default Home
